<template>
  <v-card hover @click="showUser(user), scrollToTop()" height="330px">
    <v-layout row wrap align-center justify-center>
      <v-flex pt-2 text-xs-center>
        <img
          :src="user.image"
          :style="`cursor: pointer; height: 160px; width: 160px; object-fit: cover; border-radius: 50%; border: 5px solid `+ user.color"
        />
      </v-flex>
      <v-card-text class="pa-0" style="height: 100px">
        <v-flex
          xs12
          sm12
          pt-3
          text-xs-center
          text-18-security
          font-weight-bold
          grey-security
        >{{ user.name }}</v-flex>
        <v-flex
          xs12
          sm12
          text-xs-center
          text-18-security
          font-weight-bold
          grey-security
        >{{ user.last_name }}</v-flex>
        <v-flex md12 grey-security text-14-security text-xs-center>
          {{ user.position }}
        </v-flex>
      </v-card-text>
      <v-flex
        xs12
        sm12
        md12
        pt-3
        grey-security
        text-14-security
        font-weight-bold
        text-xs-center
      >{{ user.company }}</v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    user: { type: Object, required: true },
    showUser: { type: Function, required: true },
    scrollToTop: { type: Function, required: true },
  },
}
</script>